import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AnnouncementsService } from './api/announcements.service';
import { AssessmentEntriesService } from './api/assessmentEntries.service';
import { AssessmentTargetSetsService } from './api/assessmentTargetSets.service';
import { AssessmentsService } from './api/assessments.service';
import { BundlesService } from './api/bundles.service';
import { ClientCategoriesService } from './api/clientCategories.service';
import { CoachesService } from './api/coaches.service';
import { CommentsService } from './api/comments.service';
import { ConsentService } from './api/consent.service';
import { DashboardService } from './api/dashboard.service';
import { DiningChoicesService } from './api/diningChoices.service';
import { ExerciseService } from './api/exercise.service';
import { ExerciseAttributesService } from './api/exerciseAttributes.service';
import { ExerciseCategoriesService } from './api/exerciseCategories.service';
import { ExerciseEquipmentService } from './api/exerciseEquipment.service';
import { ExercisePatternsService } from './api/exercisePatterns.service';
import { ExercisePlanesService } from './api/exercisePlanes.service';
import { ExercisePrimaryMusclesService } from './api/exercisePrimaryMuscles.service';
import { FeedService } from './api/feed.service';
import { GoalsService } from './api/goals.service';
import { GpiService } from './api/gpi.service';
import { GroupsService } from './api/groups.service';
import { HabitCategoriesService } from './api/habitCategories.service';
import { HabitEventsService } from './api/habitEvents.service';
import { HabitsService } from './api/habits.service';
import { HydrationTypesService } from './api/hydrationTypes.service';
import { IngredientTranslationsService } from './api/ingredientTranslations.service';
import { IngredientsService } from './api/ingredients.service';
import { InteractionsService } from './api/interactions.service';
import { InvitationService } from './api/invitation.service';
import { JournalService } from './api/journal.service';
import { LanguagesService } from './api/languages.service';
import { MealTranslationsService } from './api/mealTranslations.service';
import { MealsService } from './api/meals.service';
import { MeasurementsService } from './api/measurements.service';
import { MessagesService } from './api/messages.service';
import { MetabolicActivitiesService } from './api/metabolicActivities.service';
import { MetabolicTasksService } from './api/metabolicTasks.service';
import { MetricCategoriesService } from './api/metricCategories.service';
import { MetricsService } from './api/metrics.service';
import { NoteService } from './api/note.service';
import { NotificationService } from './api/notification.service';
import { OrganizationAdminsService } from './api/organizationAdmins.service';
import { OrganizationBundlesService } from './api/organizationBundles.service';
import { OrganizationSettingsService } from './api/organizationSettings.service';
import { OrganizationsService } from './api/organizations.service';
import { OverviewDayService } from './api/overviewDay.service';
import { OwnershipLevelsService } from './api/ownershipLevels.service';
import { PlansService } from './api/plans.service';
import { PresentationViewsService } from './api/presentationViews.service';
import { ProgramService } from './api/program.service';
import { QuestionsService } from './api/questions.service';
import { QuizCategoriesService } from './api/quizCategories.service';
import { QuizEventsService } from './api/quizEvents.service';
import { QuizPlanService } from './api/quizPlan.service';
import { QuizPlansService } from './api/quizPlans.service';
import { QuizQuestionsService } from './api/quizQuestions.service';
import { QuizzesService } from './api/quizzes.service';
import { RecoveryService } from './api/recovery.service';
import { RecoveryAdminService } from './api/recoveryAdmin.service';
import { ReflectionService } from './api/reflection.service';
import { ReflectionCategoriesService } from './api/reflectionCategories.service';
import { ReflectionEventsService } from './api/reflectionEvents.service';
import { ReflectionsService } from './api/reflections.service';
import { SelfDashboardService } from './api/selfDashboard.service';
import { StatisticService } from './api/statistic.service';
import { StripeService } from './api/stripe.service';
import { SubscriptionsService } from './api/subscriptions.service';
import { SuperAdminsService } from './api/superAdmins.service';
import { TagsService } from './api/tags.service';
import { TeamsService } from './api/teams.service';
import { TranslationsService } from './api/translations.service';
import { UnitsService } from './api/units.service';
import { UserAssessmentsService } from './api/userAssessments.service';
import { UserHabitEventLogsService } from './api/userHabitEventLogs.service';
import { UserHabitEventsService } from './api/userHabitEvents.service';
import { UserHydrationEntriesService } from './api/userHydrationEntries.service';
import { UserMealsService } from './api/userMeals.service';
import { UserMetricsService } from './api/userMetrics.service';
import { UserQuizEventsService } from './api/userQuizEvents.service';
import { UserQuizzesService } from './api/userQuizzes.service';
import { UserReflectionEventsService } from './api/userReflectionEvents.service';
import { UserRemindersService } from './api/userReminders.service';
import { UserSleepSessionsService } from './api/userSleepSessions.service';
import { UserWorkoutsService } from './api/userWorkouts.service';
import { UsersService } from './api/users.service';
import { VersionsService } from './api/versions.service';
import { WebhookService } from './api/webhook.service';
import { WorkoutCategoriesService } from './api/workoutCategories.service';
import { WorkoutsService } from './api/workouts.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AnnouncementsService,
    AssessmentEntriesService,
    AssessmentTargetSetsService,
    AssessmentsService,
    BundlesService,
    ClientCategoriesService,
    CoachesService,
    CommentsService,
    ConsentService,
    DashboardService,
    DiningChoicesService,
    ExerciseService,
    ExerciseAttributesService,
    ExerciseCategoriesService,
    ExerciseEquipmentService,
    ExercisePatternsService,
    ExercisePlanesService,
    ExercisePrimaryMusclesService,
    FeedService,
    GoalsService,
    GpiService,
    GroupsService,
    HabitCategoriesService,
    HabitEventsService,
    HabitsService,
    HydrationTypesService,
    IngredientTranslationsService,
    IngredientsService,
    InteractionsService,
    InvitationService,
    JournalService,
    LanguagesService,
    MealTranslationsService,
    MealsService,
    MeasurementsService,
    MessagesService,
    MetabolicActivitiesService,
    MetabolicTasksService,
    MetricCategoriesService,
    MetricsService,
    NoteService,
    NotificationService,
    OrganizationAdminsService,
    OrganizationBundlesService,
    OrganizationSettingsService,
    OrganizationsService,
    OverviewDayService,
    OwnershipLevelsService,
    PlansService,
    PresentationViewsService,
    ProgramService,
    QuestionsService,
    QuizCategoriesService,
    QuizEventsService,
    QuizPlanService,
    QuizPlansService,
    QuizQuestionsService,
    QuizzesService,
    RecoveryService,
    RecoveryAdminService,
    ReflectionService,
    ReflectionCategoriesService,
    ReflectionEventsService,
    ReflectionsService,
    SelfDashboardService,
    StatisticService,
    StripeService,
    SubscriptionsService,
    SuperAdminsService,
    TagsService,
    TeamsService,
    TranslationsService,
    UnitsService,
    UserAssessmentsService,
    UserHabitEventLogsService,
    UserHabitEventsService,
    UserHydrationEntriesService,
    UserMealsService,
    UserMetricsService,
    UserQuizEventsService,
    UserQuizzesService,
    UserReflectionEventsService,
    UserRemindersService,
    UserSleepSessionsService,
    UserWorkoutsService,
    UsersService,
    VersionsService,
    WebhookService,
    WorkoutCategoriesService,
    WorkoutsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
